import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Mobile from '@/components/Mobile'
import Questionnaire from '@/components/Questionnaire'
import Product from '@/components/Product'
import ProductSoft from '@/components/ProductSoft'
import CaseData from '@/components/CaseData'
import News from '@/components/News'
import AboutUs from '@/components/AboutUs'
import Contact from '@/components/Contact'
import TodaySummary from '@/components/TodaySummary'
import TotalSummary from '@/components/TotalSummary'
import ErrorDetail from '@/components/ErrorDetail'
import NotFound from '@/components/404'

Vue.use(Router)

function getAbsolutePath() {
  let path = location.pathname
  return path.substring(0, path.lastIndexOf('/') + 1)
}

export default new Router({
  mode: 'history',
  base: getAbsolutePath(),
  routes: [
    { path: '/', name: 'Index', component: Index },
    { path: '/questionnaire', name: 'Questionnaire', component: Questionnaire },
    { path: '/mobile', name: 'Mobile', component: Mobile },
    { path: '/product', name: 'Product', component: Product },
    { path: '/productsoft', name: 'ProductSoft', component: ProductSoft },
    { path: '/casedata', name: 'CaseData', component: CaseData },
    { path: '/news', name: 'News', component: News },
    { path: '/aboutus', name: 'AboutUs', component: AboutUs },
    { path: '/contact', name: 'Contact', component: Contact },
    { path: '/todaySummary', name: 'TodaySummary', component: TodaySummary, meta: { title: "VR训练详情" } },
    { path: '/totalSummary', name: 'TotalSummary', component: TotalSummary, meta: { title: "VR训练详情" } },
    { path: '/errorDetail', name: 'ErrorDetail', component: ErrorDetail, meta: { title: "VR训练详情" } },
    { path: '*', component: NotFound }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js